import { decodeJwt } from './decodeJwt';
import { AuthService } from './AuthService';
import { authEmitter } from './emitter';

// Basic token anomaly detection: if exp claim is in the past upon receipt, clear tokens.
export function validateAccessTokenOnSet(token: string | null) {
  if (!token) return;
  const payload = decodeJwt(token);
  if (!payload?.exp) return;
  const now = Math.floor(Date.now()/1000);
  if (payload.exp < now) {
    // stale token; clear and emit error
    // @ts-ignore private access
    (AuthService as any).access = null;
    authEmitter.emit({ type: 'error', error: 'Received expired access token; session cleared.' });
  }
}
